import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import CircularProgressBar from "../../../components/CircularProgressBar";

export default function AthleteResultsList({
  displayedAthletes,
  adjustedHeight,
  selectedAthlete,
  onSelectAthlete,
  observerTarget,
  isLoadingMore,
  hasMore,
}) {
  const isMobile = window.innerWidth < 640;

  return (
    <ul
      className="list-none p-0 overflow-y-auto pr-3 -mr-4"
      style={{
        height: `${adjustedHeight + (isMobile ? 40 : 0)}px`,
      }}
    >
      {displayedAthletes && displayedAthletes.length > 0 ? (
        <>
          {displayedAthletes.map((athlete) => {
            const isSelected = selectedAthlete?.userId === athlete.userId;
            const tier = athlete?.offerTier || "None";

            const offerAcceptanceStatus = athlete?.offerAcceptanceStatus;
            const showAcceptance =
              offerAcceptanceStatus === "Committed" ||
              offerAcceptanceStatus === "Signed";

            return (
              <li
                key={athlete.id || athlete._id || athlete.userId}
                className={`cursor-pointer shadow rounded-lg border px-3 py-2 mb-2 transition-colors shrink-0 ${
                  isSelected
                    ? "border-red-300 bg-red-50 border-l-4"
                    : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                }`}
                onClick={() => onSelectAthlete(athlete)}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-row flex-1  w-3/6 xl:w-9/12">
                    <div className="my-auto rounded-md">
                      <img
                        alt={`${athlete.name} ${athlete.lastname}`}
                        src={
                          athlete.profilePicture || "/default-profile-img.png"
                        }
                        className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                      />
                    </div>

                    <div className="ml-2 xl:ml-4 w-2/3 xl:w-9/12">
                      <p className="text-base lg:text-lg uppercase truncate">
                        {athlete.name} {athlete.lastname}
                      </p>
                      <p className="text-sm text-gray-700 line-clamp-1 ">
                        {athlete.position}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 mr-4">
                    {showAcceptance && (
                      <span
                        className={`px-3 py-1 text-xs font-normal rounded-full ${
                          offerAcceptanceStatus === "Committed"
                            ? "bg-red-100 text-red-700"
                            : "bg-blue-100 text-blue-700"
                        }`}
                      >
                        {offerAcceptanceStatus}
                      </span>
                    )}

                    <span
                      className={`px-3 py-1 text-xs font-normal rounded-full ${
                        tier === "None"
                          ? "bg-red-100 text-red-700"
                          : tier === "P4"
                            ? "bg-green-100 text-green-700"
                            : "bg-blue-100 text-blue-700"
                      }`}
                    >
                      {tier}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 xl:gap-5">
                    <CircularProgressBar
                      progress={athlete.positionScore || 0}
                      size={44}
                      strokeWidth={4}
                    />

                    <div
                      className={`ml-auto ${
                        isSelected ? "text-red-300" : "text-gray-300"
                      }`}
                    >
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="text-2xl font-bold"
                      />
                    </div>
                  </div>
                </div>
              </li>
            );
          })}

          <div ref={observerTarget} style={{ height: "1px" }} />

          {isLoadingMore && (
            <li className="flex justify-center py-4">
              <div className="text-gray-500 text-sm">
                Loading more athletes...
              </div>
            </li>
          )}

          {!hasMore && displayedAthletes.length > 0 && (
            <li className="flex justify-center py-4">
              <div className="text-gray-400 text-sm">
                All athletes loaded ({displayedAthletes.length} total)
              </div>
            </li>
          )}
        </>
      ) : (
        <div className="w-full p-2 mt-5 flex flex-col items-center">
          <img
            alt="No athletes that match your search"
            src="/nodata.gif"
            className="object-cover h-20 w-20 rounded-full border-gray-300 border"
          />

          <span className="mt-4 text-center text-md text-slate-600">
            There are no athletes that match your search
          </span>
        </div>
      )}
    </ul>
  );
}
